import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setActiveStudent, setActiveSchool } from 'actions/user';
var RedirectOld = /*#__PURE__*/function (_Component) {
  function RedirectOld() {
    var _this;
    _classCallCheck(this, RedirectOld);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RedirectOld, [].concat(args));
    _defineProperty(_this, "componentDidMount", function () {
      var studentId = _this.props.match.params.studentId;
      var pathname = window.location.pathname;
      var student = _this.props.students.find(function (student) {
        return student.id == studentId;
      });
      var paths = pathname.split('/');
      var new_url = '/';
      paths.splice(0, 3);
      paths.forEach(function (path) {
        new_url += path + '/';
      });
      if (student != null) {
        _this.switchStudent(student);
      }
      _this.props.history.push(new_url);
    });
    _defineProperty(_this, "switchStudent", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(student) {
        var activeSchool;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              activeSchool = _this.props.activeSchool;
              _context.next = 1;
              return _this.props.setActiveStudent(student);
            case 1:
              if (!(activeSchool != student.schools[0].id)) {
                _context.next = 2;
                break;
              }
              _context.next = 2;
              return _this.props.setActiveSchool(student.schools[0].id, student.id);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }
  _inherits(RedirectOld, _Component);
  return _createClass(RedirectOld, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, "Redirecting...");
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    students: state.guardians.students
  };
}
export default withRouter(connect(mapStateToProps, {
  setActiveStudent: setActiveStudent,
  setActiveSchool: setActiveSchool
})(RedirectOld));